import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { HelpdeskTaskPriorityEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk.task.priority.enum';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';
import { HelpdeskTaskPriorityNamePipe } from '@zaoblako/web/shared/pipes/helpdesk-task-priority-name.pipe';

@Component({
  selector: 'crm-priority-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent, HelpdeskTaskPriorityNamePipe],
  templateUrl: './priority-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PrioritySingleSelectComponent {
  public priorities: HelpdeskTaskPriorityEnum[] = Object.values(HelpdeskTaskPriorityEnum);

  @Input() public selectedPriority: HelpdeskTaskPriorityEnum;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public disabled: boolean;
  @Input() public appendTo: string;

  @Input() public isError = false;
  @Input() public showClear = false;

  @Output() public selectedPriorityChange = new EventEmitter<HelpdeskTaskPriorityEnum>();
}
